<main class="main-container">
    <div class="content-container">
        <div *ngIf="userType == 'estate-agent'" class="content paragraph">
            <div class="content">
                <div class="col-12 text-center">
                    <div class="heading-1 mt-3">
                        THE PROPERTY MATRIX DEAL
                    </div>
                </div>
                <div class="col-12 mt-2 paragraph">
                    <p>
                        Partner with us to market your listings professionally and win exclusive mandates — by giving
                        sellers
                        what today's
                        buyers demand: verified, upfront property intelligence.
                    </p>
                </div>
                <div class="col-12 paragraph mt-4">
                    <div class="heading-1">HERE'S HOW IT WORKS</div>
                    <ul class="checklist p-2">
                        <li>No registration fees. No hidden or click-based costs.</li>
                        <li>You keep the mandate — we strengthen your pitch.</li>
                        <li>Starter Kit. Templates. Buyer-tracing. Lead support.</li>
                        <li>Zero-risk option: No sale = No fee!</li>
                        <li>Buyers can download reports for free on your listing.</li>
                    </ul>
                </div>
                <div class="col-12 paragraph mt-4">
                    <div class="heading-1">LISTING OPTIONS</div>
                    <div class="text-heading">1. Leaflet Listings | One-page PDF</div>

                    <ul class="p-2 square-bullets">
                        <li>For all commercial categories and going concerns.</li>
                        <li>Matched instantly to the right buyers through our unique search filters.</li>
                        <li>Fast uploads branded with your own logo + contact details</li>
                    </ul>

                    <div class="text-heading">2. Level 1 : Pre-Screening Assessment | Compact report: 4–6 pages</div>
                    <ul class="p-2 square-bullets">
                        <li>Early, indicative assessment.</li>
                        <li>Focus on existing rights/zoning.</li>
                        <li>Flags value-add opportunities.</li>
                    </ul>


                    <div class="text-heading">3. Level 2 : Potenital & Risk Assessment | Full planning report: 15–20 pages
                    </div>
                    <ul class="p-2 square-bullets">
                        <li>Comprehensive investigation of future planning policies for the area.</li>
                        <li>Includes risk factors, title deed inspection*, SG diagrams (boundaries, servitudes)</li>
                        <li>Signed off by a registered planner to boost buyer confidence</li>
                        *T’s & C’s apply.
                    </ul>
                </div>
                <div class="col-12 paragraph mt-4">
                    <p class="download-link">Click <span>here</span> to download the Price Schedule</p>
                    <p class="download-link">Click <a class="download-link"
                                                      href="https://propertymatrix.blob.core.windows.net/propertymatrix-prod/PropertyMatrixDocuments/Collaboration-Agreement%20-%20Principal%20Agent%20RM.pdf" target="_blank">here</a>
                        to download the Collaboration Agreement</p>
                    <p class="download-link">Click <span>here</span> to download a Sample Level 1 Pre-screening
                        Assessment
                    </p>
                    <p class="download-link">Click <span>here</span> to download a Sample Level 2 Due Dilligence Report
                    </p>
                </div>
                <div class="row">
                    <div class="text-center">
                        <button class="button" type="button" (click)="proceed()">PROCEED</button>
                    </div>
                </div>
            </div>
        </div>

        <div *ngIf="userType == 'urban-planner'" class="content paragraph">
            <span class="title">Collaboration Agreement</span>
            <div class="col-12 paragraph mt-4">
                <ul class="p-2">
                    <li>
                        Upon approval as a Property Matrix 'associate planner', we will refer potential clients in your
                        area/metro to you at no cost.
                    </li>
                    <li>
                        Our in-house planners prepare a baseline report (70-80% completion) with deeds and planning
                        data. Your role as a registered planner involves confirming existing land use rights and
                        offering insights on potential land use and construction scope according to municipal policy.
                    </li>
                    <li>
                        Any subsequent LUMS work from the client will be directed to you as an independent consultant,
                        not as a Property Matrix associate. Planning applications can be lodged via your firm with your
                        branding.
                    </li>
                    <li>
                        Professional planning fee guidelines will be provided on our website. We encourage adherence to
                        these rates to correct market discrepancies. Discussions may be initiated if rates are
                        discounted more than 30% from our guidelines.
                    </li>
                    <li>
                        For Property Matrix-listed properties, the investigation report is seen as a 'quote' and is
                        mostly completed at risk. We remunerate R10,000 plus VAT for planning reports that facilitate
                        successful property transactions.
                    </li>
                    <li>
                        Clients not pursuing a property transaction can order Level 1, 2, or 3 investigation reports via
                        our platform for a fee.
                    </li>
                    <li>
                        Property Matrix refers potential clients to the most suitable planner in our network.
                    </li>
                    <li>
                        You'll receive remuneration for completed investigation reports ordered by clients: From R1,000
                        for Level 1 and from R4,000 for Level 2 reports contributed to.
                    </li>
                    <li>
                        Level 3 reports are project-specific, allowing collaboration with an extended network and
                        providing cost and timeframe quotations to the client.
                    </li>
                </ul>
            </div>
            <div class="col-12 paragraph mt-4">
                <p>
                    Upon successful registration, an online session will delve deeper into the Property Matrix model,
                    the summary above, and our workflow procedures.
                </p>
            </div>
            <div class="text-center">
                <button class="button" type="button" (click)="proceed()">PROCEED</button>
            </div>
        </div>
    </div>
</main>
